import { Upload as GlueUpload, UploadStatus, TriggerType } from '@tencent/glue-react-ui';
import { withAdpCombine } from '../../config/context/config';
export var AdpCombineUpload = withAdpCombine(GlueUpload);
export var Upload = Object.assign(AdpCombineUpload, {
  Card: withAdpCombine(GlueUpload.Card),
  FileList: withAdpCombine(GlueUpload.FileList),
  Trigger: withAdpCombine(GlueUpload.Trigger),
  RemoveTrigger: withAdpCombine(GlueUpload.RemoveTrigger),
  FileTrigger: withAdpCombine(GlueUpload.FileTrigger)
});
export { UploadStatus, TriggerType };